// src/components/ProtectedTeamDashboard.js
import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { db, auth } from "../firebase";
import { doc, getDoc, collection, query, where, getDocs } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import TeamDashboard from "../pages/team/TeamDashboard";

function ProtectedTeamDashboard() {
  const { teamId } = useParams();
  const [user, loading] = useAuthState(auth);
  const [authorized, setAuthorized] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkAuthorization = async () => {
      if (!user) {
        setAuthorized(false);
        return;
      }
      try {
        // Get the team document
        const teamRef = doc(db, "teams", teamId);
        const teamDoc = await getDoc(teamRef);
        if (!teamDoc.exists()) {
          setError("Team not found.");
          setAuthorized(false);
          return;
        }
        const teamData = teamDoc.data();
        console.log("Team data:", teamData);

        // Check if the user is the coach (manager)
        if (teamData.coachId === user.uid) {
          console.log("User is the coach (creator) of the team.");
          setAuthorized(true);
          return;
        }

        // Check if the user is in the team's roster
        const rosterQuery = query(
          collection(db, "rosters"),
          where("teamId", "==", teamId),
          where("playerId", "==", user.uid)
        );
        const rosterSnapshot = await getDocs(rosterQuery);
        if (!rosterSnapshot.empty) {
          console.log("User is in the team roster.");
          setAuthorized(true); // Allow access for non-managers who are members
        } else {
          console.log("User is not authorized for this team.");
          setAuthorized(false);
        }
      } catch (err) {
        console.error("Authorization error:", err);
        setError("Error checking authorization.");
        setAuthorized(false);
      }
    };

    checkAuthorization();
  }, [teamId, user]);

  if (loading) return <p>Loading...</p>;
  if (!user) return <Navigate to="/login" />;
  if (authorized === null) return <p>Checking permissions...</p>;
  if (error) return <p>{error}</p>;

  // Render the TeamDashboard for both managers and non-managers
  return <TeamDashboard />;
}

export default ProtectedTeamDashboard;
